module.exports = __webpack_public_path__ + "3c54647d1be9f38fc98a6238cfd4d421.png";